import React, { useEffect } from 'react';
import { DEVICES, Pulse, NavigationHelpers, Button, useDeviceType, Footer } from 'common-utilities';
import './style.scss';
import { EVENT_CATEGORY, REDIRECT_URL, PAYTM_CARE_URL } from '../../constants';
function Error() {
	const DEVICE = useDeviceType();
	const content = {
		heading: (sessionStorage || {}).getItem('ERROR_HEADING'),
		text: (sessionStorage || {}).getItem('ERROR_TEXT')
	};
	useEffect(() => {
		Pulse.push({
			event_action: 'email_add_expired_page_loaded',
			event_category: EVENT_CATEGORY,
			screenName: '/email_add_link_expired'
		});
	}, []);
	const redirectPaytmDeepLink =
		sessionStorage && sessionStorage.getItem('REDIRECT_PAYTM_DEEPLINK');
	return (
		<React.Fragment>
			<div className="successPageContainer">
				<div className="heading">
					{(content || {}).heading ? content.heading : 'Something went wrong'}
				</div>
				<div className="text-container">
					{(content || {}).text && content.text !== 'null'
						? content.text
						: 'We could not process your request. For further information, please raise a query at paytm.com/care'}
				</div>
				{DEVICE === DEVICES.DESKTOP ? (
					<div className="buttonContainer">
						<Button
							onClick={() => {
								Pulse.push({
									event_action: 'need_help_clicked',
									event_category: EVENT_CATEGORY,
									screenName: '/email_add_link_expired'
								});
								NavigationHelpers.redirectToPaytm(PAYTM_CARE_URL);
							}}
							oauth-id="need_help_btn"
							variant="outline-btn"
						>
							<div className="buttonText">Need Help?</div>
						</Button>
					</div>
				) : DEVICE === DEVICES.MOBILE ? (
					<div className="mobileButtonContainer">
						<button
							className="button primary"
							onClick={() => {
								Pulse.push({
									event_action: 'go_to_paytm_app_clicked',
									event_category: EVENT_CATEGORY,
									status: 'SUCCESS',
									screenName: '/email_add_link_expired'
								});
								NavigationHelpers.redirectToPaytm(redirectPaytmDeepLink);
							}}
							oauth-id="goto_paytm_btn"
						>
							Go to Paytm App
						</button>
					</div>
				) : null}
			</div>
			{DEVICE === DEVICES.DESKTOP ? (
				<Footer />
			) : (
				<Button
					onClick={() => {
						Pulse.push({
							event_action: 'need_help_clicked',
							event_category: EVENT_CATEGORY,
							screenName: '/email_add_link_expired'
						});
						NavigationHelpers.redirectToPaytm(PAYTM_CARE_URL);
					}}
					oauth-id="need_help_btn"
					variant="mobile-btn"
				>
					Need Help?
				</Button>
			)}
		</React.Fragment>
	);
}
export default Error;
